import { helper } from '@src/controls/controlHelper';
import { parseIdList } from './voucherReminderUtils';

export const DEFAULT_VOUCHER_PAGE_ID = 260;

export type AppliedVoucherRow = {
  id: number;
  name?: string;
  images?: any;
  partnerName?: string;
  startDate?: any;
  endDate?: any;
};

function firstImage(images: any): string | undefined {
  if (!images) return undefined;
  const arr = Array.isArray(images) ? images : [];
  const first = arr[0];
  if (!first) return undefined;
  if (typeof first === 'string') return first;
  return first?.url || first?.src || undefined;
}

export { firstImage };

export function getVoucherPageConfig(pageInfo?: any) {
  const voucherPageId =
    Number(
      pageInfo?.settings?.grid?.voucherPageId ||
        pageInfo?.settings?.voucherPageId ||
        DEFAULT_VOUCHER_PAGE_ID
    ) || DEFAULT_VOUCHER_PAGE_ID;
  const voucherApi =
    pageInfo?.settings?.grid?.voucherApi ||
    pageInfo?.settings?.voucherApi ||
    'get-voucher';
  return { voucherPageId, voucherApi };
}

let voucherPageCache: Record<number, any> = {};

export async function loadAppliedVoucherRows(params: {
  voucherIds: unknown;
  pageInfo?: any;
  locale?: string;
}): Promise<AppliedVoucherRow[]> {
  const ids = parseIdList(params.voucherIds);
  if (!ids.length) return [];

  const { voucherPageId, voucherApi } = getVoucherPageConfig(params.pageInfo);
  const locale = (params.locale || 'vi').split('-')[0];

  if (!voucherPageCache[voucherPageId]) {
    voucherPageCache[voucherPageId] = await helper.getPage(voucherPageId);
  }
  const vp = voucherPageCache[voucherPageId];
  if (!vp) {
    return ids.map((id) => ({ id }));
  }

  const rs: any = await helper.callPageApi(vp, voucherApi, {
    queryInput: JSON.stringify({ id: ids }),
    limit: ids.length,
    skip: 0,
    select: 'id,name,images,partnerId,provider,startDate,endDate,translations',
  });
  const data = rs?.data?.data || [];
  const byId: Record<number, any> = {};
  data.forEach((v: any) => {
    byId[Number(v.id)] = v;
  });

  return ids.map((vid) => {
    const v = byId[vid];
    if (!v) return { id: vid };
    const name =
      v?.translations?.find(
        (tr: any) => tr.language === locale || tr.locale === locale
      )?.name || v.name;
    return {
      id: vid,
      name,
      images: v.images,
      partnerName: v.partnerInfo?.name || v.provider,
      startDate: v.startDate,
      endDate: v.endDate,
    };
  });
}

export function collectCampaignUserIds(rows: any[]): number[] {
  const ids: number[] = [];
  rows.forEach((row) => {
    [row?.createdBy, row?.approvedBy, row?.rejectedBy].forEach((v) => {
      const n = Number(v);
      if (Number.isFinite(n) && n > 0) ids.push(n);
    });
  });
  return Array.from(new Set(ids));
}
